<template>
  <v-container v-if="userProfile">
    <v-container style="background: white">
      <v-row>
        <v-col cols="6">
          <v-card elevation="0">
            <p>
              Тэнxим:
              <span
                v-if="userProfile['xClassGroupProgram-2022-2023-1']"
                class="font-weight-bold"
                >{{ userProfile["xClassGroupProgram-2022-2023-1"].name2 }}</span
              >
              <span
                class="font-weight-bold text-danger"
                v-if="userProfile && userProfile.departmentName"
                >{{ userProfile.departmentName }}</span
              >
            </p>
            <p v-if="userProfile.role == 'student'">
              Оюутны код:
              <span class="font-weight-bold">{{
                userProfile.studentCode
              }}</span>
            </p>
            <p v-if="errorExists" style="color: red">Дүн байxгүй байна</p>
          </v-card>
        </v-col>
        <v-col v-if="userProfile.role == 'student' && classInfo" cols="6">
          <v-card
            width="100%"
            height="100%"
            elevation="0"
            color="teal lighten-5"
            class="py-2"
          >
            <v-row>
              <v-col cols="6">
                <v-card-text>
                  Xөтөлбөрийн нэр :<span>
                    {{ classInfo.name }},
                    <span class="font-weight-bold">
                      {{ classInfo.shortName }}-
                      {{ classInfo.classNumber }}</span
                    >
                  </span>
                  <p>{{ classInfo.xprofessiondegreeName }}</p>
                  Xөтөлбөрийн нэр :
                  <span>{{ classInfo.xcurriculumName }}</span>
                </v-card-text>
              </v-col>
              <v-col cols="6">
                Голч
                <h1>{{ userProfile.currentGPA }}</h1>
                <p>{{ userProfile.currentGPADate | formatDate }}</p>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <material-card
      v-if="
        userProfile &&
        userProfile.role == 'student' &&
        studentScores &&
        studentScores.length > 0
      "
      icon="mdi-clipboard-text"
      icon-small
      color="accent"
    >
      <h1 class="ml-2 py-2">Xичээлийн дүнгүүд</h1>
      <v-simple-table>
        <thead>
          <tr>
            <th class="primary--text">ID</th>
            <th class="primary--text">Xичээлийн код</th>
            <th class="primary--text">Хич.жил</th>
            <th class="primary--text">Улирал</th>

            <th class="primary--text">30 оноо</th>
            <th class="primary--text">70 оноо</th>
            <th class="primary--text">Дүн</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(item, index) in studentScores"
            v-bind:key="index"
            @click="_detail(item, index)"
          >
            <td>{{ index + 1 }}</td>
            <td>
              <span v-if="item.lesson">{{ item.lesson.name }}</span>
              <span class="font-weight-bold">
                ({{ item.lessonCode.toUpperCase() }})
              </span>
            </td>
            <td>{{ item.schoolYear }}</td>
            <td>{{ item.semesterName }}</td>
            <td>{{ item.score30 }}</td>
            <td>{{ item.score70 }}</td>

            <td v-if="item.scoreTotal">
              <span class="font-weight-bold">{{ item.scoreTotal }}</span>
            </td>
            <td v-else><span class="red--text">Дүнгүй</span></td>
          </tr>
        </tbody>
      </v-simple-table>
    </material-card>
  </v-container>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import { mapState } from "vuex";
import LessonTable from "@/views/lessons/LessonTable.vue";
import moment from "moment";
export default {
  props: {},
  data() {
    return {
      errorExists: false,
      test: "/schools/YJHjHWUGDok8teDhDIKX/students/am14d001/scores",
      studentScores: null,
      studentScores2:null,
      selectedSemester: null,
      classInfo: null,
    };
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
    filteredScores: function () {
      if (this.selectedSemester != null) {
        return this.studentScores;
        // return this.studentScores.filter(
        //   (item) =>
        //     item.department &&
        //     item.department.ref.path === this.selectedDepartment.ref.path
        // );
      } else {
        return this.studentScores;
      }
    },
  },
  async created() {
    this.userProfile.ref.get().then(async (student) => {
      var yy = await student.data();
      if (
        yy &&
        yy["xClassGroupProgramRef-2022-2023-1"] &&
        yy["xClassGroupProgramRef-2022-2023-1"]
      ) {
        yy["xClassGroupProgramRef-2022-2023-1"].get().then((doc) => {
          let classInfo = doc.data();
          classInfo.ref = doc.ref;
          classInfo.id = doc.id;
          this.classInfo = classInfo;
        });
      } else {
        if (
          yy &&
          yy["xClassGroupProgram-2022-2023-1"] &&
          yy["xClassGroupProgram-2022-2023-1"].ref
        ) {
          yy["xClassGroupProgram-2022-2023-1"].ref.get().then((doc) => {
            let classInfo = doc.data();
            classInfo.ref = doc.ref;
            classInfo.id = doc.id;
            this.classInfo = classInfo;
          });
        }
      }
    });
   
    if (this.userProfile.studentCode)
      this._searchStudentScore1(this.userProfile.studentCode);
    this._searchStudentScore2(this.userProfile.id);

    // if (this.userProfile.studentCode)
    //   this._searchStudentScore1("nee22d003");
    // this._searchStudentScore2("1Hm5oufwDvQpwJB4E3kZ");
 
  },
  methods: {
    _searchStudentScore1(studentCode) {
      fb.db
        .collectionGroup("yearScores")
        .where("studentCode", "==", studentCode)
        .onSnapshot((querySnapshot) => {
          this.studentScores = [];
          var counter = 0;
          querySnapshot.forEach(async (doc) => {
            let score = doc.data();
            score.ref = doc.ref;
            score.id = doc.id;
            score.index = ++counter;
            console.log(score.lessonCode);
            var datas = await fb.db
              .collection("/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/")
              .where("code", "==", score.lessonCode)
              .limit(1)
              .get();
            if (!datas.empty) {
              var doc = datas.docs[0];
              if (doc != null && doc.exists) {
                score.lesson = doc.data();
              }
            } else {
              // this.accessOK = false
            }
            console.log(score);
            this.studentScores.push(score);
          });
          if (querySnapshot.empty) {
            this.errorMessage = "No Score!";
          }
        });
    },
    _searchStudentScore2(studentCode) {
      fb.db
        .collectionGroup("yearScores")
        .where("id", "==", studentCode)
        .onSnapshot((querySnapshot) => {
          var counter = 0;
          this.studentScores2 = [];
          querySnapshot.forEach(async (doc) => {
            let score = doc.data();
            score.ref = doc.ref;
            score.id = doc.id;
            score.index = ++counter;
            console.log(score.ref.path);

            if (score.lessonCode) {
              var datas = await fb.db
                .collection("/schools/YJHjHWUGDok8teDhDIKX/lessons-standards/")
                .where("code", "==", score.lessonCode)
                .limit(1)
                .get();
              if (!datas.empty) {
                var doc = datas.docs[0];
                if (doc != null && doc.exists) {
                  score.lesson = doc.data();
                }
              } else {
                // this.accessOK = false
              }
            }

            this.studentScores2.push(score);
          });
          if (querySnapshot.empty) {
            this.errorMessage = "No Score!";
          }
        });
    },
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>
